import { Icon, IconArrowRight } from "@flixbus/honeycomb-icons-react";
import { Box, Heading, Text } from "@flixbus/honeycomb-react";
import * as React from "react";
import * as css from "./ArticleInfoBox.scss";

type ArticleInfoBoxProps = {
  headline: string | JSX.Element;
  category: string | JSX.Element;
  onClick?: () => void;
};

const ArticleInfoBox: React.FC<ArticleInfoBoxProps> = ({ headline, category, onClick }) => {
  return (
    <Box extraClasses={css.box} onClick={onClick}>
      <div>
        <Heading size={3} extraClasses={css.heading}>
          {headline}
        </Heading>
        <Text small extraClasses={css.category}>
          {category}
        </Text>
      </div>
      <div className={css.iconWrapper}>
        <Icon InlineIcon={IconArrowRight} extraClasses={css.icon} />
      </div>
    </Box>
  );
};

export default ArticleInfoBox;
